export class Debit {
  id: number;
  spend_account_id: number;
  amount: number;
  effective_date: string | null;
  reporter: string | null;
  source_type: string;
  reason: string | null;

  constructor(data: any) {
    this.id = data.id;
    this.spend_account_id = data.spend_account_id;
    this.amount = Number(data.amount ?? 0);
    this.effective_date = data.effective_date ?? null;
    this.reporter = data.reporter ?? null;
    this.source_type = data.source_type ?? "MANUAL";
    this.reason = data.reason ?? null;
  }
}
